export default function(slideLength) {
    return {
        slideLength,
        current: 0,
        prev: 0,
        init() {
            this.slideElements = [].slice.call(this.$refs.container.children);
            this.$refs.container.style.height = this.getCurrentElement().offsetHeight + 'px';
            this.slideElements.forEach((child) => {
                
                child.addEventListener('transitioncancel', () => {
                    this.$refs.container.style.height = this.getCurrentElement().offsetHeight + 'px';
                })
            })
            
            window.addEventListener('resize', () => {
                this.$refs.container.style.height = this.getCurrentElement().offsetHeight + 'px';
            })
        },
        getCurrentElement() {
            return this.slideElements[this.current];
        },
        next() {
            this.prev = this.current,
            this.current = this.current + 1;
            if (this.current > this.slideLength - 1) {
                this.current = 0;
            }
        },
        previous () {
            this.prev = this.current;
            this.current = this.current - 1;
            if (this.current < 0) {
                this.current = this.slideLength - 1;
            }
        },
        
        getSlideDirection() {
            return this.current > this.prev ? 'left' : 'right'
        },
        slideTransitions: {
            ['x-transition:enter']() {
                return 'enter'
            },
            ['x-transition:enter-start']() {
                return `enter-start-${this.getSlideDirection()}`
            },
            ['x-transition:enter-end']() {
                return `enter-end-${this.getSlideDirection()}`
            },
            ['x-transition:leave']() {
                return 'leave'
            },
            ['x-transition:leave-start']() {
                return `leave-start-${this.getSlideDirection()}`
            },
            ['x-transition:leave-end']() {
                return `leave-end-${this.getSlideDirection()}`
            },
        }
    }
}